/* eslint-disable import/no-cycle */
import React, { memo } from "react";

import styled from "styled-components";

import { Section } from "@origin-digital/ods-core";
import { CardBackgroundVariant } from "@origin-digital/ods-types";

import { screenNames } from "@/constants";

import { StyledCard, defaultStyleCardProps } from "./StyledCard";

export const StyledSection = styled(Section)(() => ({
  "&&": {
    minHeight: "100%",
  },
}));

type ScreenProps = {
  id: string;
  children: JSX.Element;
  backgroundColor?: CardBackgroundVariant;
};

/**
 * Layout the outer bound of the question.
 */
export const Screen = memo(({ id, children, backgroundColor }: ScreenProps) => {
  const isRecommendationScreen = location.pathname.includes(
    screenNames.recommendation
  );
  const isSoftQuote = location.pathname.includes(screenNames.softQuote);
  const isRoofMaterial = location.pathname.includes(screenNames.roofMaterial);
  const isBatteryOutlook =
    location.pathname.includes(screenNames.batteryOutlook) &&
    !location.pathname.includes(screenNames.solarBatteryOutlook);
  const isSolarBatteryOutlook = location.pathname.includes(
    screenNames.solarBatteryOutlook
  );
  const isHardStop = location.pathname.includes(screenNames.hardStop);

  const maximumWidthScreens = [
    screenNames.recommendation,
    screenNames.softQuote,
    screenNames.confirmation,
    screenNames.batteryOutlook,
    screenNames.solarBatteryOutlook,
  ].some((screen) => location.pathname.includes(screen));

  const getCardPadding = () => {
    if (isRecommendationScreen || isSolarBatteryOutlook) {
      return "none";
    } else if (isRoofMaterial || isHardStop) {
      return "xlarge";
    } else {
      return "xxxlarge";
    }
  };

  return (
    <StyledSection
      id={id}
      data-id={id}
      backgroundColor={backgroundColor}
      hideGutter={isRecommendationScreen || isBatteryOutlook}
      stretchY
    >
      <StyledCard
        stretchY={true}
        paddingXSpecific={{
          xs: isSoftQuote || isBatteryOutlook ? "none" : "small",
          xl: getCardPadding(),
        }}
        paddingYSpecific="none"
        backgroundColor={backgroundColor}
        maxWidth={maximumWidthScreens ? "100%" : defaultStyleCardProps.maxWidth}
      >
        {children}
      </StyledCard>
    </StyledSection>
  );
});
